import PDFObject from 'pdfobject';
import invoiceFn from '../pdfs/invoice';

const pdfMake = require('pdfmake/build/pdfmake.js');
// const pdfFonts = require('pdfmake/build/vfs_fonts.js');
const pdfFonts = require('../pdfs/vfs_fonts.js');

pdfMake.fonts = {
  Helvetica: {
    normal: 'Helvetica-Regular.ttf',
    bold: 'Helvetica-Bold.ttf'
    // italics: 'fontFile3.ttf',
    //  bolditalics: 'fontFile4.ttf'
  }
};

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default async function(invoice, i18n, locale, uid) {
  const model = await invoiceFn(invoice, i18n, locale, uid);
  return pdfMake.createPdf(model.doc, model.tableLayouts);
}
